import mobileCarousel from '../utils/mobileCarousel';
mobileCarousel('color-icon-boxes__slider', 'swiper-pagination-icon-boxes', 1.1, 0);
